import { createCompareModal } from './create-compare-modal'
import { selectProductOption } from './select-product-option'
import { createProductSlider } from './product-slider'
import { productPropsStart } from '../product-props/'

const productView = document.querySelector('.product-view')
if (productView) {
  const productOptionsElements = productView.querySelectorAll('.product-option')

  const compareModal = createCompareModal(productView)
  const compareButton = productView.querySelector('[open-compare-modal]')

  createProductSlider(productView)

  productOptionsElements.forEach((item) => {
    item.addEventListener('click', () => {
      selectProductOption(productView, item.dataset.optionId, compareModal)
    })
  })
  if (compareButton) {
    compareButton.addEventListener(
      'click',
      compareModal.open.bind(compareModal)
    )
  }

  productPropsStart(productView)

  // productOptionsElements[0].dispatchEvent(new Event('click'))
}
